"use strict";
/*
 * Copyright (C) 2017-2019 HERE Europe B.V.
 * Licensed under Apache 2.0, see full license in LICENSE
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
const harp_utils_1 = require("@here/harp-utils");
const Expr_1 = require("./Expr");
const InterpolatedProperty_1 = require("./InterpolatedProperty");
const logger = harp_utils_1.LoggerManager.instance.create("TechniqueAttr");
function evaluateTechniqueAttr(context, attrValue, defaultValue) {
    const env = context instanceof Expr_1.Env ? context : context.env;
    let evaluated;
    if (attrValue instanceof Expr_1.Expr) {
        try {
            evaluated = attrValue.evaluate(env, Expr_1.ExprScope.Value, !(context instanceof Expr_1.Env) ? context.cachedExprResults : undefined);
        }
        catch (error) {
            logger.error(`failed to evaluate expression '${JSON.stringify(attrValue)}': ${error}`);
            evaluated = undefined;
        }
    }
    else if (InterpolatedProperty_1.isInterpolatedProperty(attrValue)) {
        const storageLevel = context instanceof Expr_1.Env ? context.lookup("$zoom") : context.zoomLevel;
        evaluated = InterpolatedProperty_1.getPropertyValue(attrValue, storageLevel);
    }
    else {
        evaluated = attrValue;
    }
    if (evaluated === undefined || evaluated === null) {
        return defaultValue;
    }
    else {
        return evaluated;
    }
}
exports.evaluateTechniqueAttr = evaluateTechniqueAttr;
